module.exports = __webpack_public_path__ + "img/student.59bfe91f.jpg";